import type { FC } from 'react';
import type { SettingsRecipeT } from './component';
import {
  RateRecipeBtn,
  RecipeAuthor,
  RecipeDescription,
  RecipeImageMobile,
  RecipeIsPromo,
  RecipeMobileTabs,
  RecipePFC,
  RecipeStats,
  RecipeTip
} from './components/components';
import RecipeAddAllToCart from './components/RecipeAddAllToCart';
const RecipeLaptop: FC<SettingsRecipeT> = ({
  toggleLeaveRecipeFeedbackModal,
  scrollToCommentsBlock,
  recipe,
  handleRecipeFavorites,
  isFavorite,
  isTablet,
  isWithoutPhotos
}) => {
  if (!recipe) {
    return null;
  }
  return (
    <div className='mb-14'>
      <div className='relative grid mb-8'>
        <div className=''>
          <RecipeImageMobile
            scrollToCommentsBlock={scrollToCommentsBlock}
            comments={recipe.comments_number}
            date={recipe.date}
            rating={recipe.rating}
            viewCount={recipe.viewCount}
            title={recipe.title}
            rubric={recipe.bludoItem?.title}
            isFavorite={isFavorite}
            handleRecipeFavorites={handleRecipeFavorites}
            mainImage={recipe?.attachmentsItem?.cacheItem?.[0]?.filePath}
            video_code={recipe.video_code}
            isTablet={isTablet}
          />
        </div>
        <div className='mb-3'>
          {!!recipe.is_product_promo && <RecipeIsPromo />}
        </div>
        <RecipeStats
          calories={recipe.calories}
          difficulty={recipe.recipes_difficult}
          serving={recipe.serving}
          time={recipe.cooking_time}
        />
        <RecipePFC
          protein={recipe.protein}
          fat={recipe.fat}
          carbohydrates={recipe.carbohydrates}
          calories={recipe.calories}
        />
        <div className=''>
          <RecipeDescription text={recipe.text} />

          <RecipeAuthor
            fio={recipe.authorItem?.fio}
            identify={recipe.authorItem?.identify}
            title={recipe.authorItem?.title}
            avatar={
              recipe.authorItem?.userItem?.attachmentsItem?.tempFullFilePath
            }
          />
        </div>
      </div>
      <RecipeMobileTabs
        video_code={recipe.video_code}
        isTablet={isTablet}
        isWithoutPhotos={isWithoutPhotos}
        recipeInstructions={recipe.recipeInstructions}
        recipeIngredients={recipe.recipeIngredients}
      />
      {recipe.tip && (
        <div className=''>
          <RecipeTip tip={recipe.tip} isGrey={!!recipe.video_code} />
        </div>
      )}
      <div className='fixed bottom-0 left-0 z-10 w-full p-3 bg-white grid grid-cols-2 gap-x-2.5 pb-8'>
        <RateRecipeBtn
          _votedRating={recipe._votedRating}
          toggleLeaveRecipeFeedbackModal={toggleLeaveRecipeFeedbackModal}
        />
        <RecipeAddAllToCart
          catalogItemsIds={
            recipe.recipeIngredients
              ?.filter(
                item =>
                  item.ingredientsItems?.[0]?.catalogItem?.available &&
                  item?.ingredientsItems?.[0]?.catalogItem?.id
              )
              ?.map(
                item => item?.ingredientsItems?.[0]?.catalogItem?.id as string
              ) || []
          }
        />
      </div>
    </div>
  );
};

export default RecipeLaptop;
